/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Giveaways1Inputs */

const id_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway`)
};

const ms_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberian`)
};

const da_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const de_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const en_us2_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const es_es2_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regalos`)
};

const es_mx2_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regalos`)
};

const fil_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Giveaway`)
};

const fr_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuités`)
};

const it_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway`)
};

const hu_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajándékok`)
};

const nl_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const no_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways`)
};

const pl_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozdania`)
};

const pt_br2_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos grátis`)
};

const pt_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas grátis`)
};

const ro_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte gratuite`)
};

const fi_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaisjaot`)
};

const sv_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utlottningar`)
};

const vi_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tặng miễn phí`)
};

const tr_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedava Oyunlar`)
};

const cs_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výprodeje`)
};

const bg_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатни игри`)
};

const ru_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Раздачи`)
};

const uk_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Роздачі`)
};

const ar_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الهدايا`)
};

const hi_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गिवअवे`)
};

const th_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ของแจกฟรี`)
};

const ja_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配布`)
};

const zh_cn2_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费赠送`)
};

const zh_hant1_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費贈送`)
};

const ko_offerdetail_overview_giveaways1 = /** @type {(inputs: Offerdetail_Overview_Giveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 배포`)
};

/**
* | output |
* | --- |
* | "Giveaways" |
*
* @param {Offerdetail_Overview_Giveaways1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_giveaways1 = /** @type {((inputs?: Offerdetail_Overview_Giveaways1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Giveaways1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_giveaways1(inputs)
	if (locale === "ms") return ms_offerdetail_overview_giveaways1(inputs)
	if (locale === "da") return da_offerdetail_overview_giveaways1(inputs)
	if (locale === "de") return de_offerdetail_overview_giveaways1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_giveaways1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_giveaways1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_giveaways1(inputs)
	if (locale === "fil") return fil_offerdetail_overview_giveaways1(inputs)
	if (locale === "fr") return fr_offerdetail_overview_giveaways1(inputs)
	if (locale === "it") return it_offerdetail_overview_giveaways1(inputs)
	if (locale === "hu") return hu_offerdetail_overview_giveaways1(inputs)
	if (locale === "nl") return nl_offerdetail_overview_giveaways1(inputs)
	if (locale === "no") return no_offerdetail_overview_giveaways1(inputs)
	if (locale === "pl") return pl_offerdetail_overview_giveaways1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_giveaways1(inputs)
	if (locale === "pt") return pt_offerdetail_overview_giveaways1(inputs)
	if (locale === "ro") return ro_offerdetail_overview_giveaways1(inputs)
	if (locale === "fi") return fi_offerdetail_overview_giveaways1(inputs)
	if (locale === "sv") return sv_offerdetail_overview_giveaways1(inputs)
	if (locale === "vi") return vi_offerdetail_overview_giveaways1(inputs)
	if (locale === "tr") return tr_offerdetail_overview_giveaways1(inputs)
	if (locale === "cs") return cs_offerdetail_overview_giveaways1(inputs)
	if (locale === "bg") return bg_offerdetail_overview_giveaways1(inputs)
	if (locale === "ru") return ru_offerdetail_overview_giveaways1(inputs)
	if (locale === "uk") return uk_offerdetail_overview_giveaways1(inputs)
	if (locale === "ar") return ar_offerdetail_overview_giveaways1(inputs)
	if (locale === "hi") return hi_offerdetail_overview_giveaways1(inputs)
	if (locale === "th") return th_offerdetail_overview_giveaways1(inputs)
	if (locale === "ja") return ja_offerdetail_overview_giveaways1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_giveaways1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_giveaways1(inputs)
	return ko_offerdetail_overview_giveaways1(inputs)
});
export { offerdetail_overview_giveaways1 as "offerDetail.overview.giveaways" }